import apiHandler from "../core/apiHandler";
const branchConfigApi = apiHandler('configuration/branches');
export default branchConfigApi;
